module.exports = __webpack_public_path__ + "static/media/slightly-disagree.84799c5e.svg";